function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { initializerDefineProperty as _initializerDefineProperty, applyDecoratedDescriptor as _applyDecoratedDescriptor } from "../_virtual/_rollupPluginBabelHelpers.js";
import uniq from 'lodash.uniq';
import { observable, computed, action } from 'mobx';
import { mapAssignmentKeyAndNameToParties, mapAssignmentKeyToParties } from "../helpers/fieldAssignment.js";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var AssignmentStore = (_class = (_temp = /*#__PURE__*/function () {
  function AssignmentStore(pdfStore) {
    _classCallCheck(this, AssignmentStore);

    this.pdfStore = void 0;

    _initializerDefineProperty(this, "options", _descriptor, this);

    _initializerDefineProperty(this, "setOptions", _descriptor2, this);

    _initializerDefineProperty(this, "findOptionByKey", _descriptor3, this);

    _initializerDefineProperty(this, "findOptionsByType", _descriptor4, this);

    _initializerDefineProperty(this, "findDefaultOptionForType", _descriptor5, this);

    this.pdfStore = pdfStore;
  }

  _createClass(AssignmentStore, [{
    key: "defaultOption",
    get: function get() {
      return this.options.find(Boolean);
    }
  }, {
    key: "assignmentTypes",
    get: function get() {
      return uniq(this.options.map(function (option) {
        return option.assignmentType;
      }));
    }
  }, {
    key: "updatePartyAssignments",
    value: function updatePartyAssignments(field, assignedTo, partyName) {
      if (field.data.dataType === 'autofill') return;
      var parties = mapAssignmentKeyAndNameToParties(assignedTo, partyName, this.pdfStore.documentPartyMappings);
      field.updateData({
        parties: parties,
        value: undefined
      });
    }
  }]);

  return AssignmentStore;
}(), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "options", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "defaultOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignmentTypes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "assignmentTypes"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "setOptions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this = this;

    return function (options) {
      _this.options = options;
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "findOptionByKey", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (key) {
      return _this2.options.find(function (option) {
        return option.assignmentKey === key;
      });
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "findOptionsByType", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (type) {
      return _this3.options.filter(function (option) {
        return option.assignmentType === type;
      });
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "findDefaultOptionForType", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (type) {
      var options = _this4.findOptionsByType(type);

      var defaultOption = options.find(function (opt) {
        return opt.defaultOptionForAssignmentType;
      });

      if (_this4.pdfStore.documentPartyMappings.length) {
        return [defaultOption].concat(_toConsumableArray(options)).find(function (option) {
          var partiesForAssignmentKey = mapAssignmentKeyToParties(option === null || option === void 0 ? void 0 : option.assignmentKey, _this4.pdfStore.documentPartyMappings);
          return partiesForAssignmentKey.length;
        });
      } else if (defaultOption) {
        return defaultOption;
      }

      return options[0];
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "updatePartyAssignments", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updatePartyAssignments"), _class.prototype)), _class);
export default AssignmentStore;